<template>
  <b-dropdown variant="orange" size="sm" block no-caret class="ml-4" id="shortcut-help-popover">
    <template #button-content>
      <i class="fa fa-keyboard-o text-white" aria-hidden="true"></i>
    </template>
    <b-dropdown-text style="width: 300px">
      <table id="table_help">
        <tr>
          <th>Operations</th>
          <th>Keyboard Shortcut</th>
        </tr>
        <tr v-for="(item, index) in keyShortcuts_" :key="index">
          <td>
            {{ operations[index].split("_")[0] }}{{ " "
            }}{{ operations[index].split("_")[1] }}
          </td>
          <td>ctrl+{{ keyShortcuts_[index] }}</td>
        </tr>
      </table>
    </b-dropdown-text>
    <!-- <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item class="p-0 m-0">
    </b-dropdown-item> -->
  </b-dropdown>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "SalesDetails",
  components: {},

  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    operations: [],
    loading: null,
    selected: {},
    customer: null,
    shop: null,
    fetchCount: 0,
    removeSalesLoading: false,
    query: null,
    selectedCustomer: null,
    customerSearchList: [{ name: "Walk in customer", id: 1 }],
    shopSearchList: [{ name: "DEFAULT", id: 1 }],
    selectedShop: null,
  }),
  methods: {
    // Selected Item For Sales ReturnFunction

    Change_Json_to_Array() {},
    async onChangeCustomer(value) {
      this.customer = value?.id;
      await this.fetchSales();
    },

    onChangeShop(value) {
      this.shop = value?.id;
      this.fetchSales();
    },
    activeSalesReturn(event) {
      this.salesReturnVisible = true;
      this.$store.dispatch("salesReturn/setSalesReturnDatas", event);
      this.$store.dispatch(
        "salesReturn/setVisibleSalesReturn",
        this.salesReturnVisible
      );

      this.$store.dispatch("salesReturn/fetchProductsSalesReturn", {
        salesid: event.id,
      });
      this.hideModal();
    },

    searchCustomer(search, loading) {
      this.$store
        .dispatch("customer/search", { query: search })
        .then((res) => {
          this.customerSearchList = res.data.data;
        })
        .catch((err) => {});
    },

    searchShop(search, loading) {
      this.$store
        .dispatch("shops/search", { query: search })
        .then((res) => {
          this.shopSearchList = res.data.data;
        })
        .catch((err) => {});
    },

    moment(date) {
      return moment(date).format("LL");
    },
    fetchSales() {
      this.loading1 = true;
      this.$store
        .dispatch("sales/fetchSales", {
          query: this.query,
          customer: this.customer,
          shop: this.shop,
        })
        .then((res) => {
          this.loading1 = false;
          this.sales = res.data.data;
        })
        .catch((err) => {
          this.loading1 = false;
          this.sales = [];
        });
    },

    showModal() {
      this.loading = true;

      setTimeout(() => {
        this.fetchSales();
      }, 200);
      this.$refs.ModalShortcutHelp.show();
      this.loading = false;
    },
    hideModal() {
      this.$refs.ModalShortcutHelp.hide();
    },

    onSelect(id) {
      this.fetchReturnInfo(id);
      this.hideModal();
    },
    fetchReturnInfo(id) {
      this.$store.dispatch("sales/fetchSalesInfo", { id });
    },
  },

  computed: {
    ...mapState("sales", ["sales"]),
    ...mapState("salesReturn", ["sales_return_details"]),
    ...mapState("salesReturn", ["sales_return_products"]),
    ...mapState("auth", ["keyShortcuts"]),
    keyShortcuts_: {
      get() {
        this.operations = Object.keys(this.keyShortcuts);
        const short_cuts = Object.values(this.keyShortcuts);

        return short_cuts;
      },
      set() {},
    },
  },

  created() {
    this.searchCustomer();
    this.searchShop();
  },
};
</script>
<style scoped>
.returnButton {
  height: 29px;
  width: 62px;
  color: white;
  background: blueviolet;
  border-radius: 17px;
  border: antiquewhite;
}

#table_help {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#table_help td,
#table_help th {
  border: 1px solid #ddd;
  padding: 8px;
}

#table_help tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* #table_help tr:hover {
  background-color: #f9f9f9;
} */

#table_help th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #f9f9f9;
  color: #5f6983;
}
</style>
